import React from 'react'
import {Doughnut} from 'react-chartjs-2'
import PropTypes from 'prop-types';
import {objectWithoutProperties} from '../../../../utils/utils'


//================ Property Value Type =====================
const propsType={
    children:PropTypes.node,
};

//================ Default Property Value =====================
const defaultProps={
    
};

const DoughnutChart=(props)=>{

    const _props=props,
            children=_props.children,
            className=_props.className,
            attribute=objectWithoutProperties(props,'children');
        
    return (
        React.createElement(
            Doughnut,
            {className:className,attribute},
            children
        )
    )
}

DoughnutChart.propTypes=propsType;
DoughnutChart.defaultProps=defaultProps;

export default DoughnutChart;